module.exports = __webpack_public_path__ + "static/media/menuHandler.55d7dc0d.svg";